import React, { useEffect, useState } from "react";
import CentralDashboardService from "../../services/centraldashboard.service";
import moment from "moment";

function KmAndFuelReport() {
  const currentDate = moment(new Date()).format("YYYY-MM-DD");

  const [dates, setDates] = useState({
    fromDate: currentDate,
    toDate: currentDate,
  });
  const [data, setData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [searchVal, setSearchVal] = useState("");

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    setDates({ ...dates, [name]: value });
  };

  const fetchData = () => {
    const req = {
      fromdate: moment(dates.fromDate).format("YYYY-MM-DD"),
      todate: moment(dates.fromDate).format("YYYY-MM-DD"),
    };
    CentralDashboardService.getDutyWithFuel(req)
      .then((response) => {
        setMainData(response.data);
        setData(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchData();
  }, [dates]);

  const thStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "left",
    background: "#f5f5f5",
    width: "33%", // evenly spread
  };

  const tdStyle = {
    padding: "10px",
    border: "1px solid #ddd",
  };

  const handleSearch = (e) => {
    setSearchVal(e.target.value);

    if (e.target.value === "") {
      setData(mainData);
      return;
    }

    const keyword = e.target.value.toLowerCase();

    const filteredData = mainData.filter((item) =>
      Object.values(item).some(
        (value) => value && value.toString().toLowerCase().includes(keyword),
      ),
    );

    setData(filteredData);
  };

  return (
    <div className="h-100">
      <div className="graph-header mb-2">
        <div className="graph-heading">Duty & Fuel Report</div>
        <div>
          <input
            type="search"
            style={{
              borderRadius: "4px",
              fontSize: "14px",
              padding: "2px 10px",
              outline: "none",
              boxShadow: "none",
            }}
            placeholder="Search..."
            value={searchVal}
            onChange={handleSearch}
          />
        </div>
        <div className="graph-yearly-filter">
          <div className="d-flex flex-column justify-content-start">
            {/* <small>From Date:</small> */}
            <input
              type="date"
              onChange={handleDateChange}
              name="fromDate"
              value={dates.fromDate}
              style={{ borderRadius: "4px", fontSize: "14px" }}
              max={currentDate}
            />
          </div>
          {/* <div className="d-flex flex-column justify-content-start">
            <small>To Date:</small>
            <input
              type="date"
              onChange={handleDateChange}
              name="toDate"
              value={dates.toDate}
              style={{ borderRadius: "4px", fontSize: "14px" }}
              min={dates.fromDate}
              max={currentDate}
            />
          </div> */}
        </div>
      </div>
      <div style={{ height: "92%", overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead
            style={{
              position: "sticky",
              top: 0,
              background: "#fff",
              zIndex: 1,
            }}
          >
            <tr>
              <th style={thStyle}>Bus No.</th>
              <th style={thStyle}>Fuel</th>
              <th style={thStyle}>
                Duty No.{" "}
                <small style={{ color: "rgb(241, 127, 65)" }}>
                  (Total:{" "}
                  {data?.reduce(
                    (sum, item) => Number(sum) + Number(item.dutyCount),
                    0,
                  )}
                  )
                </small>
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td style={tdStyle}>{item.vechicl_no}</td>
                <td style={tdStyle}>{item.fuel || "-"}</td>
                <td style={tdStyle}>
                  {item.duty_no}
                  <span className="ms-2" style={{ color: "rgb(241, 127, 65)" }}>
                    ({item.dutyCount})
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default KmAndFuelReport;
